
import Header from './components/Header';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import LocationsMap from './components/LocationsMap';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function Contact() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Car2Go",
    "description": "Contact Car2Go for car rental inquiries, reservations, and customer support in East Brunswick, New Jersey",
    "url": `${import.meta.env.VITE_SITE_URL || "https://www.cartogo.co"}/contact`,
    "mainEntity": {
      "@type": "AutoRental",
      "name": "Car2Go",
      "telephone": "+1 (732) 900-3478",
      "email": "info@cartogo.co",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "28 Hollis Rd",
        "addressLocality": "East Brunswick",
        "addressRegion": "NJ",
        "postalCode": "08816",
        "addressCountry": "US"
      },
      "openingHours": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          "opens": "06:00",
          "closes": "22:00"
        }
      ],
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+1 (732) 900-3478",
          "contactType": "customer service",
          "availableLanguage": "English",
          "areaServed": "New Jersey"
        },
        {
          "@type": "ContactPoint",
          "email": "info@cartogo.co",
          "contactType": "customer service",
          "availableLanguage": "English"
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Contact Car2Go | Car Rental Customer Service East Brunswick NJ"
        description="Contact Car2Go for car rental reservations, customer support, and inquiries in East Brunswick, NJ. Phone: +1 (732) 900-3478, Email: info@cartogo.co. Professional car rental service with 24/7 support."
        keywords="contact car rental, car rental customer service, East Brunswick contact, car rental reservations, customer support"
        canonical={`${import.meta.env.VITE_SITE_URL || "https://www.cartogo.co"}/contact`}
        ogTitle="Contact Car2Go - Car Rental Customer Service East Brunswick"
        ogDescription="Contact Car2Go for car rental reservations and customer support in East Brunswick, NJ. Professional service with 24/7 availability."
        schemaData={schemaData}
      />
      <Header />
      <ContactHero />
      <ContactInfo />
      <ContactForm />
      <LocationsMap />
      <Footer />
    </div>
  );
}